<template>
    <v-btn
    :color="selectableMolecule.selected ? 'white':'grey'"
    @click="pressButton"
    :title="selectableMolecule.molecule.inchi">
      {{label}}
    </v-btn>
</template>

<script>
export default {
  name: 'SelectableMolecule',

  props: ['selectableMolecule'],
  
  methods: {
    pressButton () {
      if(this.selectableMolecule.selected) {
        this.unselect();
      }else{
        this.select();
      }
    },
    unselect () {
      this.$emit('unselect-molecule', this.selectableMolecule.molecule);
    },
    select () {
      this.$emit('select-molecule', this.selectableMolecule.molecule);
    }
  },
  computed: {
    label: function() {
      // IUPAC name property can be undefined.
      let iupacName = this.selectableMolecule.molecule.primaryName
      let alias = ""
      if(this.selectableMolecule.molecule.aliases.length) {
        alias = this.selectableMolecule.molecule.aliases[0].alias
      }
      return !iupacName ? alias : iupacName
    }
  }
};
</script>